import { type HTMLAttributes, type ReactNode } from 'react';
import type { Theme } from '../../types/enums';
import type { TextAlignType, TextFormatType } from './enum';

export type TextOnlyTheme = Theme.BLUE | Theme.GREEN | Theme.ORANGE | Theme.PURPLE | Theme.RED;
export interface TitleConfigProptypes {
  formatType?: TextFormatType;
  text?: string;
  color?: string;
  alignment?: TextAlignType;
}
export interface DescriptionConfigPropTypes {
  description: string;
  color?: string;
  alignment?: TextAlignType;
}
export interface TextOnlyPropsTypes extends HTMLAttributes<HTMLDivElement> {
  titleConfig: TitleConfigProptypes;
  descriptionConfig: DescriptionConfigPropTypes;
  backgroundColor?: string;
  theme?: TextOnlyTheme;
  borderRadius?: string;
  className?: string;
}

export const allowedTagVariants = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
} as const;

export type AllowedTag = keyof typeof allowedTagVariants;

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  align?: 'center' | 'left' | 'right';
  as?: AllowedTag;
  children: ReactNode;
  color?: string;
  theme?: string;
}
